var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c(
        "w-card-title",
        [
          _vm._v(" " + _vm._s(_vm.$ct("logos")) + " "),
          _c("w-spacer"),
          _c(
            "w-link",
            {
              attrs: { white: "" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "times" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-scroll-view",
        [
          _c(
            "w-card-content",
            [
              _c("app-file-upload", {
                attrs: {
                  label: _vm.$ct("upload"),
                  sending: _vm.sending,
                  "allowed-extensions": _vm.allowedExtensions,
                },
                on: {
                  input: function ($event) {
                    return _vm.onFileInput($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-list",
            _vm._l(_vm.allImages, function (img, i) {
              return _c(
                "w-list-item",
                { key: i },
                [
                  _c("w-list-item-icon", [
                    _c("span", {
                      staticClass: "thumbnail",
                      style: {
                        backgroundImage: `url(${encodeURI(img.getUrl())})`,
                      },
                    }),
                  ]),
                  _c("w-list-item-text", { style: { overflowX: "hidden" } }, [
                    _vm._v(" " + _vm._s(img.Name) + " "),
                  ]),
                  _c(
                    "w-list-item-action",
                    { style: { flexShrink: 0, flexGrow: 0 } },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("tooltip.use-image"),
                              expression: "$ct('tooltip.use-image')",
                            },
                          ],
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.useImage(img)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "check" } })],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "w-list-item-action",
                    { style: { flexShrink: 0, flexGrow: 0 } },
                    [
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.$ct("tooltip.remove-image"),
                              expression: "$ct('tooltip.remove-image')",
                            },
                          ],
                          staticClass: "danger",
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              return _vm.removeImg(img)
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "times" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }